
import React, { useRef } from "react"
import Slider from "react-slick"
import { useStaticQuery, graphql } from "gatsby"
import { storyblokEditable } from "gatsby-source-storyblok"

const NewsSlider = ({blok}) => {

  const { corpNews } = useStaticQuery(graphql`
  query {
    corpNews: allStoryblokEntry(
      filter: {field_component: {eq: "blogArticle"}, full_slug: {regex: "/^ja/corporate-news/"}}
      sort: {published_at: DESC}
      limit: 20
    ) {
      edges {
        node {
          uuid
          name
          content
          full_slug
          slug
          published_at(formatString: "MM/DD/YYYY")
        }
      }
    }
  } 
  `)
  corpNews.edges.forEach((e) => {
    e.node.content = typeof e.node.content === 'string' ? JSON.parse(e.node.content) : e.node.content;
  })
  // console.log(corpNews)

  let sliderRef = useRef(null)
  const next = () => {
    sliderRef.current.slickNext()
  }
  const previous = () => {
    sliderRef.current.slickPrev()
  }

  const settings = {
    autoplay: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  }

  const NewsItem = ({node}) => {
    // console.log(node)
    return (<div className="text-sm" {...storyblokEditable(node.content)}><a href={`/${node.full_slug}`}>{node.content?.title}</a></div>)
  }

  return (
    <div className="news-slider-section w-full py-3 border-b" {...storyblokEditable(blok)}>
        <div className="xl:max-w-screen-xl mx-auto slider-container text-center relative">
          <div className="max-w-[280px] sm:max-w-screen-lg mx-auto my-0">
            <Slider ref={sliderRef} {...settings}>{corpNews.edges?.map((e, index) => (<NewsItem node={e.node} key={index} />))}</Slider>
          </div>
          <button className="absolute top-1 left-[10px] button block bg-white" onClick={previous}>
            <img className="w-[34px] h-[11px] rotate-180" src="/icons/arrow-black-right.svg" alt="Prev button"/>
          </button>
          <button className="absolute top-1 right-0 button block bg-whit" onClick={next}>
            <img className="w-[34px] h-[11px]" src="/icons/arrow-black-right.svg" alt="Next button"/>
          </button>
        </div>
    </div>
  )
}

export default NewsSlider
